import styled from "styled-components";

export const LiteTradeSearchHeaderStyled = styled.h2`
    font-weight: normal;
    overflow: hidden;
    transition: height .35s ease;
    height: 40px;
    margin-bottom: 16px;
    
    &.hidden {
        height: 0;
        margin-bottom: 0;
    }
`;

export const LiteTradeSearchStyled = styled.div`
    position: relative;
    display: flex;
    margin-bottom: 24px;

    .cancel-button {
        width: 70px;
        transition: width .35s ease;
        overflow: hidden;
        padding: 0;
        border: none;
        margin-left: 8px;
        color: var(--color-label-primary);
        font-size: 14px;
        font-weight: 600;

        &:hover {
            color: var(--color-label-secondary);
        }

        &.hidden {
            margin-left: 0;
            width: 0;
        }
    }
    input {
        padding: 16px 56px;
        font-size: 16px;
    }
    svg {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        
        &.search-icon {
            left: 16px;
        }
        
        &.clear-icon {
            right: 16px;
            fill: var(--color-label-secondary);
        }
    }
`;
